"use client";
import BAG_SHARP_ICON from "@assets/svg/bag_sharp.svg";
import BUILDING_ICON from "@assets/svg/building.svg";
import PEOPLE_CALL_ICON from "@assets/svg/people_call.svg";
import { useRuntimeConfig } from "@lib/env";
import Image from "next/image";
import Link from "next/link";

function HighLightsNav() {
  const { config, loading } = useRuntimeConfig();

  const hotline = loading ? "..." : config.NEXT_PUBLIC_HOTLINE || "0945416666";

  return (
    <>
      <Link href="/store-placement" className="flex gap-2 items-center hover:opacity-80 transition">
        <Image src={BUILDING_ICON} alt="Hệ thống showroom" width={20} height={20} />
        <div>Hệ thống showroom</div>
      </Link>
      <a
        href="https://honganh.vn"
        target="_blank"
        rel="noopener noreferrer"
        className="flex gap-2 items-center hover:opacity-80 transition"
      >
        <Image src={BAG_SHARP_ICON} alt="Dành cho doanh nghiệp" width={20} height={20} />
        <div>Dành cho doanh nghiệp</div>
      </a>
      <a href={`tel:${hotline}`} className="flex gap-2 items-center hover:opacity-80 transition">
        <Image src={PEOPLE_CALL_ICON} alt={`Hotline ${hotline}`} width={20} height={20} />
        <div>Hotline {hotline}</div>
      </a>
    </>
  );
}

export default HighLightsNav;
